// extracted by mini-css-extract-plugin
export default {"root":"Documents_root__KILLB"};